export const MFA_CODE_LENGTH = 6;
export const MFA_CODE_EXPIRATION_SECONDS = 60;
export const EMAIL_CHANGE_CODE_EXPIRATION_SECONDS = 10 * 60;
